(function() {
    const revealElements = document.querySelectorAll('.scroll-reveal');
    const revealCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    };
    const revealOptions = { threshold: 0.1, rootMargin: "0px 0px 50px 0px" };
    const revealObserver = new IntersectionObserver(revealCallback, revealOptions);
    revealElements.forEach(el => revealObserver.observe(el));
    
    // Failsafe para mostrar todo si no se hace scroll
    setTimeout(() => {
        revealElements.forEach(el => el.classList.add('visible'));
    }, 4000);
})();
